import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import Translate from 'react-translate-component';
import { Alert } from 'antd';

import { withRouteOptions } from 'components/hocs/withRouteOptions';
import { getUser, getCompanyInfo } from 'actions/asyncActions';
import ProfileForm from 'components/views/profile/ProfileForm';
import FieldWithLabel from 'components/common/form/FieldWithLabel';
import ProfileUploadAvatar from './ProfileUploadAvatar';

@connect(state => ({ user: getUser.selectData(state), companyInfo: getCompanyInfo.selectData(state) }))
@withRouteOptions
export default class ProfileView extends Component {
    static routeOptions = {
        title: 'menu.profile'
    }

    static propTypes = {
        user: PropTypes.object.isRequired,
        companyInfo: PropTypes.object
    }

    render() {
        const { user, user: { email, username, login, needUpdatePassword }, companyInfo: { sso } } = this.props;

        return (
            <div className="profile">
                { sso ? (
                    <Fragment>
                        <h3 className="profile-head">
                            <Translate content='profile.privateInfo.title' component="span"/>
                        </h3>
                        <div className="card-body">
                            <FieldWithLabel label='common.email'>{email}</FieldWithLabel>
                            <FieldWithLabel label='common.fullName'>{username}</FieldWithLabel>
                            <FieldWithLabel label='common.login'>{login}</FieldWithLabel>
                        </div>
                    </Fragment>
                ) : (
                    <Fragment>
                        <h3 className="profile-head">
                            <Translate content='profile.privateInfo.title' component="span"/>
                        </h3>
                        <div className="card-body">
                            <Alert className="profile-description"
                                message={<Translate content='profile.privateInfo.about' />}
                                type="info"
                            />
                            { needUpdatePassword &&
                                <Alert message={<Translate content='profile.form.needUpdatePassword' />} type="warning"/>
                            }
                            { !!user.permissions.education && (
                                <ProfileUploadAvatar user={user} />
                            )}
                            <FieldWithLabel label='common.email'>{email}</FieldWithLabel>
                            <FieldWithLabel label='common.fullName'>{username}</FieldWithLabel>
                            <FieldWithLabel label='common.login'>{login}</FieldWithLabel>
                            <ProfileForm />
                        </div>
                    </Fragment>
                )}
            </div>
        );
    }
}
